<div class="wrapper">
  <h2 class="accent-color">{{titulo}}</h2>

  <div class="card-header-right">
    <div class="card-stats">
      <span>Total:</span>
      <span class="card-stat-value">{{ total | currency:'BRL' }}</span>
      <span class="card-stat-divider">|</span>
      <span>Selecionados:</span>
      <span class="card-stat-value">{{ totalSelecionado | currency:'BRL' }}</span>
    </div>

    <mat-divider [vertical]="true" class="card-header-divider"></mat-divider>
    <button class="accent-color btn-adicionar" mat-raised-button matTooltip="Adicionar linha" (click)="addRowAndFocus()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<div class="table-container">
  <form [formGroup]="form">
    <div formArrayName="rows">

      <p-table [value]="rows.controls" [scrollable]="true" scrollHeight="flex"
        selectionMode="multiple" [(selection)]="selectedRows">

          <ng-template pTemplate="header">
            <tr>
              <th>Valor</th>
              <th>Tipo</th>
              <th>Observações</th>
            </tr>
          </ng-template>

          <!-- Modelo da Tabela primaria -->
          <ng-template #body let-row let-rowIndex="rowIndex">
            <tr [formGroupName]="rowIndex" class="row-group" [pSelectableRow]="row">
              
              <td>
                <div class="floatlabel-field">
                  <p-floatlabel variant="on">
                    <p-inputNumber inputId="{{ prefix }}-valor-{{ rowIndex }}" #valorInput mode="currency"
                      currency="BRL" formControlName="valor" [useGrouping]="false" styleClass="w-full"
                      [min]="0" data-field="valor" (onFocus)="selectInputText($event)" />
                    <label>Valor</label>
                  </p-floatlabel>
                  <small class="p-error"
                    [ngClass]="{'visibility-hidden': !getFormGroup(rowIndex).get('valor')?.hasError('required_if_not_empty') || !getFormGroup(rowIndex).get('valor')?.touched }">Campo
                    obrigatório</small>
                </div>
              </td>
              
              <td>
                <div class="floatlabel-field">
                  <app-generic-autocomplete [items]="tiposLancamento" displayField="nome" label="Tipo de lançamento"
                    inputId="{{ prefix }}-tipoLancamento-{{ rowIndex }}" formControlName="tipoLancamento" 
                    data-field="tipoLancamento" (onBlur)="onAutoCompleteBlur($event)" 
                    (onFocus)="selectInputText($event)" 
                    (keydown)="tabToNextComponentOnAutocomplete($event, rowIndex, 'tipoLancamento')">
                  </app-generic-autocomplete>
                  <small class="p-error"
                    [ngClass]="{'visibility-hidden': !getFormGroup(rowIndex).get('tipoLancamento')?.hasError('required_if_not_empty') || !getFormGroup(rowIndex).get('tipoLancamento')?.touched }">Campo
                    obrigatório</small>
                </div>
              </td>

              <td>
                <p-floatlabel variant="on">
                  <textarea [id]="prefix + '-observacoes-' + rowIndex" pInputTextarea rows="1"
                    data-field="observacoes" formControlName="observacoes" class="w-[full] align-middle observacoes-textarea"
                    (click)="$event.preventDefault()"
                    (keydown)="createNewRowOnTab($event, rowIndex, 'observacoes')"></textarea>
                  <label>Observações</label>
                </p-floatlabel>
              </td>

            </tr>
          </ng-template>

        </p-table>
    </div>
  </form>
</div>